import { styled } from '@nuskin/foundation-theme';

export const SubscriptionRewardContainer = styled.div`
    display: flex;
    flex-direction: row;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-top: 10px;
    border: 1px solid #e0e0e0;

    @media (max-width: 767px) {
        flex-direction: column;
        padding: 10px;
    }
`;

export const CardImage = styled.img`
    width: 40%;
    height: 345px;
    display: block;
    object-fit: cover;

    @media (max-width: 767px) {
        width: 100%;
        border-radius: 10px 10px 0 0;
    }
`;

export const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 40px;
    width: 60%;
    background-color: #f5f5f5;

    @media (max-width: 767px) {
        width: 100%;
        padding: 20px;
    }
`;

export const CardHeader = styled.h2`
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 10px;
`;

export const CardText = styled.p`
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #252525;
    margin-top: 2rem;
`;

export const CardButton = styled.button`
    width: 257px;
    margin-top: 15px;
    background-color: #252525;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background-color: #8c8c8c;
    }
`;

export const CardLogo = styled.img`
    max-width: 360px;
`;
